import React, {useEffect} from 'react';
import withStyles from '@mui/styles/withStyles';
import BlueBox from '../shared/blue-box';
import {Box, Typography} from '@mui/material';
import rulesman from '../../assets/images/rule_man.png';
import BackIcon from '@mui/icons-material/ArrowBack';
import {useHistory} from 'react-router-dom';

const styles = theme => ({
  root: {
    color: '#fff',
    padding: 24,
    marginBottom: 80,
    backgroundColor: '#fff',
    borderRadius: '0 0 0 60px',
  },
  headingBox: {
    paddingTop: 120,
  },
  heading: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#000',
    marginLeft: 20,
  },
  body: {
    fontSize: 14,
    fontWeight: 100,
    color: '#000',
    marginTop: 10,
  },
  ruleImage: {
    height: 50,
  },
  backIcon: {
    zIndex: 100,
    position: 'absolute',
    left: 24,
    top: 40,
    color: '#fff',
  },
});

const DataProtection = ({classes}) => {
  let history = useHistory();
  useEffect(() => {
    const wrapper = document.querySelector('.scrollable');
    if (!wrapper) return;

    document.querySelector('.scrollable').addEventListener(
      'touchmove',
      function(event) {
        event.stopPropagation();
      },
      false,
    );
  });

  return (
    <>
      <BackIcon className={classes.backIcon} onClick={history.goBack} />
      <BlueBox text="Newsletter" />
      <div className="scrollable">
        <Box height="100%" className={classes.root}>
          <Box className={classes.headingBox} display="flex">
            <img src={rulesman} className={classes.ruleImage} alt="rule icon" />
            <Typography
              align="left"
              variant="body1"
              component="p"
              className={classes.heading}>
              Lorem Ipsum ...
            </Typography>
          </Box>
          <Typography
            align="left"
            variant="body1"
            component="p"
            className={classes.body}>
            When one door of happiness closes, another opens, but often we look
            so long at the closed door that we do not see the one that has been
            opened for us.
          </Typography>
        </Box>
      </div>
    </>
  );
};

export default withStyles(styles)(DataProtection);
